<template>
  <div class="tinymceEditor">
    <vue-tinymce v-model="myValue" :setting="{ ...setting, ...extraSetting }" />
  </div>
</template>

<script>
export default {
  name: "tinyMce",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    extraSetting: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      myValue: this.value,
      formData: new FormData(),
      upLoadImg: null,
      setting: {
        body_class: "editTinymce",
        menubar: false,
        toolbar:
          "bold italic underline strikethrough blockquote | superscript subscript | image charmap table | alignleft aligncenter alignright alignjustify | kityformula-editor | image",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar:
          "removeformat | bold italic underline strikethrough blockquote",
        plugins:
          "importcss image table fullscreen quickbars charmap kityformula-editor paste",
        paste_auto_cleanup_on_paste: true,
        paste_remove_styles: true,
        paste_remove_styles_if_webkit: true,
        paste_strip_class_attributes: true,
        paste_as_text: true,
        language: "zh_CN", //本地化设置
        forced_root_block: "", //去掉p标签
        height: 350,
        placeholder: this.placeholder,
        content_css: "/static/css/tinymce.css",
        formats: {
          blockquote: { inline: "span", classes: "docx_dot" },
          underline: { inline: "u" },
        },
        images_upload_handler: this.generalUpload, //图片自定义上传
        content_style: ".editTinymce img { width: 100%; height: auto;}",
        // images_upload_url: this.upLoadImg,
        // images_upload_base_path: "/iamge",
      },
    };
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit("input", newValue);
    },
  },
  methods: {
    // 通用上传接口
    async generalUpload(blobInfo, succFun) {
      try {
        this.formData.append("file", blobInfo.blob());
        let data = await this.$store.dispatch("questionBank/generalUpload", {
          file: this.formData,
        });
        console.log("generalUpload", data);
        if (data.location) {
          console.log("data.location", data.location);
          this.upLoadImg = data.location;
        }
        succFun(data.location);
        console.log("succFun", succFun);
      } catch (error) {
        console.log("generalUpload", error);
      }
    },
    //
    // cleanup(input) {
    //   const div = document.getElementsByClassName("cell");
    //   div.innerHTML = input;
    //   return div.innerText;
    // },
  },
};
</script>

<style lang="scss">
::v-deep {
  .editTinymce {
    background: #f5f6f8;
    img {
      width: 100%;
      height: auto;
    }
  }
}
.tox .tox-statusbar {
  display: none !important;
}
.tox .tox-toolbar,
.tox .tox-toolbar__overflow,
.tox .tox-toolbar__primary {
  background-color: #f5f6f8 !important;
}
.tox .tox-editor-container {
  border: 1px solid #dddddd;
  border-radius: 6px;
  height: 264px;
}
.tox-tinymce {
  border: none !important;
}
.tox .tox-dialog {
  z-index: 3000 !important;
}
.tox-tinymce-aux {
  z-index: 3000 !important;
}
</style>
